import { RJSFSchema } from '@rjsf/utils';

export const PpConfigSchema: RJSFSchema = {
    type: "object",
    properties: {
        clientId: { type: 'string' },
        secret: {type: 'string'},
        sandbox: {type: 'number'},
    }
  }